import { Component, Element, h, Host, Prop, Watch } from "@stencil/core";
import { StzhMostsearchedItem, StzhVbzQuicklink } from "../../../../index";
import { StzhVbzIntroLocalizedText } from "./stzh-vbz-intro.localization";

/**
 * @slot ticker - slot for ticker content 
 */
@Component({
  tag: "stzh-vbz-intro",
  styleUrl: "stzh-vbz-intro.scss",
  scoped: true,
})
export class StzhVbzIntro {
  @Element() element: HTMLStzhVbzIntroElement;

  /** Translation strings. */
  @Prop() localization: StzhVbzIntroLocalizedText;

  /** Most searched items */
  @Prop() quicklinks: StzhVbzQuicklink[] | string = [];
  private _quicklinks: StzhMostsearchedItem[] = [];

  @Watch("quicklinks")
  quicklinksWatcher(newValue: StzhVbzQuicklink[] | string) {
    if (!newValue) {
      this._quicklinks = [];
    } else if (typeof newValue === "string") {
      try {
        this._quicklinks = JSON.parse(newValue);
      } catch (e) {
        this._quicklinks = [];
      }
    } else {
      this._quicklinks = newValue;
    }
  }

  private init = () => {
    this.quicklinksWatcher(this.quicklinks);
  };

  async componentWillLoad() {
    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "vbz-intro");
    }
  }

  connectedCallback() {
    this.init();
  }

  render() {
    const classes = {
      "stzh-vbz-intro": true,
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-vbz-intro__ticker">
            <slot name="ticker"></slot>
          </div>
          {this._quicklinks.length > 0 && (
            <div class="stzh-vbz-intro__quicklinks">
              <stzh-heading class="stzh-vbz-intro-quicklinks__heading">
                {this.localization.quicklinksHeading}
              </stzh-heading>
              {this._quicklinks.map(item => (
                <div class="stzh-vbz-intro-quicklink">
                  <stzh-link class="stzh-vbz-intro-quicklink__link" href={item.href} icon={"arrow-right"}>
                    {item.label}
                  </stzh-link>
                </div>
              ))}
            </div>
          )}
        </div>
      </Host>
    );
  }
}
